// Single-Flight-Guard fuer den Login-Redirect.
//
// Beim Cold-Load ohne Session laufen mehrere API-Calls parallel auf 401; ohne
// Guard kann jede 401-Stelle (und jedes Re-Render) eine eigene Navigation auf
// `/auth/login` ausloesen. Jeder Aufruf erzeugt serverseitig einen neuen
// OIDC-`state` und ueberschreibt den einen Handshake-Cookie -> der Callback
// scheitert mit "unexpected state". Der Modul-Guard stellt sicher, dass pro
// Page-Load genau EINE Navigation passiert.

let loginRedirectInFlight = false;

// Marker fuer einen bewusst durchgefuehrten Logout (#95). Liegt der Marker in der
// Tab-Session, darf KEIN Auto-Redirect auf /auth/login mehr feuern: der Hub hat
// sein Session-Cookie zwar geloescht, die Entra-SSO-Session lebt aber u. U. weiter.
// Ein sofortiger /auth/login wuerde den User dann still wieder einloggen ("Seite
// refreshed, aber weiterhin eingeloggt"). Der Marker ueberlebt den Entra-Logout-
// Round-Trip (gleiche Origin, gleicher Tab) und haelt den abgemeldeten Zustand.
const LOGGED_OUT_KEY = "msq_hub_logged_out";

function safeSessionStorage(): Storage | null {
  try {
    return globalThis.sessionStorage ?? null;
  } catch {
    // Zugriff kann im Privat-/Hardened-Modus werfen — nie eskalieren lassen.
    return null;
  }
}

/** Markiert die aktuelle Tab-Session als bewusst abgemeldet (#95). */
export function markLoggedOut(): void {
  try {
    safeSessionStorage()?.setItem(LOGGED_OUT_KEY, "1");
  } catch {
    // Logout darf nie an sessionStorage scheitern.
  }
}

/** True, solange in dieser Tab-Session ein bewusster Logout markiert ist. */
export function isLoggedOut(): boolean {
  try {
    return safeSessionStorage()?.getItem(LOGGED_OUT_KEY) === "1";
  } catch {
    return false;
  }
}

/** Loescht den Logout-Marker (z. B. bei bewusstem Re-Login). */
export function clearLoggedOut(): void {
  try {
    safeSessionStorage()?.removeItem(LOGGED_OUT_KEY);
  } catch {
    // ignore
  }
}

export function redirectToLogin(): void {
  // Nach explizitem Logout NICHT still re-authentifizieren (#95).
  if (isLoggedOut()) return;
  if (loginRedirectInFlight) return;
  loginRedirectInFlight = true;
  const target = `/auth/login?redirect=${encodeURIComponent(window.location.pathname)}`;
  window.location.assign(target);
}

/** Bewusster Re-Login nach Logout: Marker loeschen und zum Login navigieren. */
export function signInAgain(): void {
  clearLoggedOut();
  loginRedirectInFlight = false;
  redirectToLogin();
}

/** Nur fuer Tests: setzt den Modul-Guard zurueck. */
export function resetLoginRedirectGuardForTests(): void {
  loginRedirectInFlight = false;
}
